import { controls,grouped } from "../controls";
const number_format_rules = {
label: "Number Format Rules",
pageLabel: "Number Format Rules",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Sequence"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "sequence",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Nlength"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "nlength",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Fieldname"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "fieldname",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Selectionrule"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "selectionrule",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Modelname"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "modelname",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Filtercond"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "filtercond",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Fixedval"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "fixedval",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:false, label: "Isstring", name: "isstring" }),
...controls.checkBox({ tab: "filter",default:false, label: "Isautoinc", name: "isautoinc" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Sequence",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "sequence",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Nlength",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "nlength",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fieldname",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "fieldname",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Selectionrule",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "selectionrule",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Modelname",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "modelname",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Filtercond",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "filtercond",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fixedval",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "fixedval",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Isstring",default:false, name: "isstring" }),
...controls.checkBox({ tab: "general", label: "Isautoinc",default:false, name: "isautoinc" }),
]
,history:{
perPage: 10,
reportHeader: "Number Format Rules",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Sequence",accessor: "sequence",},
{Header: "Nlength",accessor: "nlength",},
{Header: "Fieldname",accessor: "fieldname",},
{Header: "Selectionrule",accessor: "selectionrule",},
{Header: "Modelname",accessor: "modelname",},
{Header: "Filtercond",accessor: "filtercond",},
{Header: "Fixedval",accessor: "fixedval",},
{Header: "Isstring",accessor: "isstring",type:'tick'},
{Header: "Isautoinc",accessor: "isautoinc",type:'tick'},
]}};
export default number_format_rules;